{
  "appName": "NRG CMX",
  "loading": "Laden…",
  "retry": "Opnieuw proberen",
  "cancel": "Annuleren",
  "save": "Opslaan",
  "search": "Zoeken",
  "noResults": "Geen resultaten",
  "pagination": {
    "root": "paginering",
    "rootFor": "paginering {{table}}",
    "first": "Eerste pagina",
    "previous": "Vorige pagina",
    "next": "Volgende pagina",
    "last": "Laatste pagina",
    "page": "Pagina {{page}} van {{totalPages}}",
    "range": "{{start}}–{{end}} van {{total}}",
    "compact": "{{page}} / {{totalPages}}",
    "rowsPerPage": "Rijen per pagina"
  },
  "logout": "Uitloggen",
  "forbidden": {
    "title": "Geen toegang",
    "body": "Je account heeft geen toegang tot NRG CMX.",
    "signedInAs": "Ingelogd als {{email}}",
    "contact": "Neem contact op met de beheerder van je organisatie om toegang aan te vragen."
  },
  "topbar": {
    "search": {
      "placeholder": "Zoek laadpunten, locaties, pagina's…",
      "label": "Globaal zoeken",
      "shortcutHint": "{{key}} K",
      "openLabel": "Zoeken openen",
      "clearLabel": "Zoekopdracht wissen",
      "dialogTitle": "Zoeken",
      "resultsLabel": "Zoekresultaten",
      "minChars": "Typ minimaal {{min}} tekens om te zoeken.",
      "searching": "Bezig met zoeken…",
      "empty": "Geen resultaten voor “{{query}}”.",
      "error": "Sommige bronnen konden nu niet worden doorzocht — de resultaten kunnen onvolledig zijn.",
      "stationCount_one": "{{count}} laadpunt",
      "stationCount_other": "{{count}} laadpunten",
      "groups": {
        "pages": "Pagina's",
        "stations": "Laadpunten",
        "locations": "Locaties",
        "meteringPoints": "Meetpunten"
      }
    },
    "language": {
      "label": "Weergavetaal",
      "nl": "NL",
      "en": "EN",
      "ariaLabel": "Schakel taal naar {{language}}"
    },
    "notifications": {
      "label": "Meldingen ({{count}} ongelezen)",
      "title": "Meldingen",
      "subtitle": "Live meldingen over je portfolio",
      "empty": "Je bent helemaal bij.",
      "markAllRead": "Alles als gelezen markeren",
      "items": {
        "erasmus-mc-over-threshold": {
          "title": "Erasmus MC verbruik boven drempel",
          "description": "Live belasting 149 kW overschrijdt de limiet van 130 kW."
        },
        "equinix-am4-grid-spike": {
          "title": "Equinix AM4 netpiek",
          "description": "Netinvoer raakte 12 minuten lang 213 kW aan."
        },
        "ing-csrd-attention": {
          "title": "ING hoofdkantoor CSRD-aandacht",
          "description": "Drie CSRD-metingen moeten bijgewerkt vóór de audit."
        },
        "almere-pv-underperform": {
          "title": "Almere PV onderpresteert",
          "description": "Twee strings zitten 18% onder de dagprognose."
        },
        "noordereiland-meter-stale": {
          "title": "Noordereiland meter offline",
          "description": "Logger #4 heeft 22 minuten niet gerapporteerd."
        },
        "rotterdam-port-permit-due": {
          "title": "Rotterdam Haven vergunning verloopt",
          "description": "Verlengvenster sluit over 6 dagen."
        },
        "leiden-bess-firmware": {
          "title": "Leiden BESS firmware beschikbaar",
          "description": "Leverancier heeft een routine-update - veilig in te plannen."
        }
      }
    },
    "breadcrumb": {
      "ariaLabel": "Breadcrumb",
      "cpoAnalytics": "CPO-analyse",
      "qrPayment": "QR-betaling",
      "alerts": "Meldingen",
      "sessionSchedules": "Sessieplanning",
      "helpdesk": "Helpdesk",
      "billing": "Financiën",
      "splitBilling": "Verdeelafspraak",
      "invoices": "Facturen",
      "fees": "Kosten",
      "oda": "ODA-bemetering"
    }
  },
  "nav": {
    "sections": {
      "cpms": "CPMS",
      "energy": "Energie",
      "support": "Support",
      "billing": "Financiën"
    },
    "oda": "ODA-bemetering",
    "cpoAnalytics": "CPO-analyse",
    "qrPayment": "QR-betaling",
    "alerts": "Meldingen",
    "sessionSchedules": "Sessieplanning",
    "helpdesk": "Helpdesk",
    "splitBilling": "Verdeelafspraak",
    "invoices": "Facturen",
    "checklist": "Checklist",
    "fees": "Kosten"
  },
  "sidebar": {
    "access": {
      "domain": "Domein",
      "tenant": "Tenant",
      "organisation": "Organisatie"
    }
  },
  "combobox": {
    "more": "nog {{count}} - typ verder om te filteren"
  }
}
